const comments = [
  {
    name: '光影追梦人',
    date: '2026年7月28日',
    rating: 5,
    content: '用了好几个影视网站，6080新视觉影院是最流畅的。画质清晰不说，加载速度真的很快，基本点开就能看，再也不用等缓冲了。片源也很丰富，新上映的电影过几天就能找到。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20abstract%20minimalist%20portrait%20with%20soft%20cinematic%20lighting%2C%20simple%20geometric%20style%2C%20golden%20amber%20tones%2C%20profile%20silhouette%20with%20gentle%20gradient%2C%20clean%20background&width=100&height=100&seq=avatar-comment-01&orientation=squarish',
  },
  {
    name: '周末影迷',
    date: '2026年7月25日',
    rating: 5,
    content: '每天下班回家就想找部好片放松一下，6080真的很方便，分类清晰片库又大。最惊喜的是连一些冷门的老电影都能找到，简直是电影爱好者的宝藏网站。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20abstract%20minimalist%20portrait%20with%20soft%20cinematic%20lighting%2C%20simple%20geometric%20style%2C%20warm%20rose%20tones%2C%20profile%20silhouette%20with%20gentle%20gradient%2C%20clean%20background&width=100&height=100&seq=avatar-comment-02&orientation=squarish',
  },
  {
    name: '追剧小达人',
    date: '2026年7月20日',
    rating: 5,
    content: '追剧追到停不下来！更新速度超快，当天播的剧当天就能看到高清版。手机上看也很流畅，地铁上、午休时间随时都能追，已经安利给身边所有朋友了。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20abstract%20minimalist%20portrait%20with%20soft%20cinematic%20lighting%2C%20simple%20geometric%20style%2C%20warm%20taupe%20tones%2C%20profile%20silhouette%20with%20gentle%20gradient%2C%20clean%20background&width=100&height=100&seq=avatar-comment-03&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            真实反馈
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            用户评价
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            来自影迷们的真实声音，是我们不断优化体验的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment) => (
            <article key={comment.name} className="rounded-2xl bg-background-100 p-6 md:p-7">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: comment.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm text-primary-500"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}